import DefaultFooter from '../../footer/default-footer.component';
import { NavigationHeader } from '../../header/navigation-header/navigation-header.component';
import { QuickActions } from '../quick-actions.component';

const AllQuickActions = () => {
    return (
        <div className='bg-background-default flex h-dvh flex-col'>
            <NavigationHeader title='Quick actions' />
            <div className='size-lf-stretch bg-background-default inline-flex h-full flex-col items-start justify-start gap-6 px-5 py-6'>
                <QuickActions orientation='vertical' />
            </div>
            <DefaultFooter />
        </div>
    );
};

export default AllQuickActions;
